var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.reportUrl != null)?_c('report-table',{ref:"report_table",attrs:{"id":"report_table","title":_vm.reportTitle,"selectable":"","report-url":_vm.reportUrl},on:{"report-retrieved":_vm.handleReportRetrieved}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }